
import { projectTestimonials } from '../../../mocks/projects';

export default function ProjectsTestimonials() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="text-orange-500 text-xs md:text-sm font-semibold mb-3 tracking-widest uppercase">Testimonios</div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Lo que Dicen Nuestros{' '}
            <span className="bg-gradient-to-r from-orange-500 to-green-500 bg-clip-text text-transparent">Clientes</span>
          </h2>
          <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto">
            Empresas líderes confían en PACKTO para transformar sus procesos productivos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {projectTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer group"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-orange-400 text-sm"></i>
                  </div>
                ))}
              </div>

              <p className="text-sm text-gray-600 leading-relaxed mb-6 italic">
                &ldquo;{testimonial.text}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-xs text-gray-500">{testimonial.role}, {testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
